'use client';
import { useEffect, memo } from 'react';
import { changeLanguage } from '@root/src/i18n/client';

const DesktopLanguageSelectorClient = props => {
  useEffect(() => {
    const containerId = `${props.switchButtonID}Container`;
    const wrapperId = `${props.switchButtonID}Wrapper`;
    const dropdown = document.getElementById(containerId);
    const switchButton = document.getElementById(props.switchButtonID);
    const wrapper = document.getElementById(wrapperId);

    if (!dropdown || !switchButton || !wrapper) return;

    const closeDropdown = () => {
      dropdown.classList.add('hidden');
    };

    const toggleDropdown = () => {
      if (dropdown.classList.contains('hidden')) {
        dropdown.classList.remove('hidden');
      } else {
        dropdown.classList.add('hidden');
      }
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (!wrapper.contains(event.target as Node)) {
        closeDropdown();
      }
    };

    switchButton.addEventListener('click', toggleDropdown);
    document.addEventListener('click', handleClickOutside);
    window.addEventListener('scroll', closeDropdown, { passive: true });

    return () => {
      switchButton.removeEventListener('click', toggleDropdown);
      document.removeEventListener('click', handleClickOutside);
      window.removeEventListener('scroll', closeDropdown);
    };
  }, [props.switchButtonID]);

  const handleChangeLanguage = (lang: string) => {
    document
      .getElementById(`${props.switchButtonID}Container`)
      ?.classList.add('hidden');
    changeLanguage(lang);
  };

  return (
    <div
      id={`${props.switchButtonID}Container`}
      className="absolute left-0 mt-2 w-[88px] overflow-hidden rounded-2xl border border-[#d9c6a0] bg-[#f9f3e9] shadow-[0_12px_32px_rgba(34,58,39,0.18)] ring-1 ring-white/60 z-10 hidden"
    >
      <ul className="py-1 text-center">
        <li
          className="cursor-pointer px-3 py-2 text-[12px] font-medium text-[#4b5a42] transition-colors duration-200 hover:bg-[#e7decd] hover:text-[#223A27] md:text-sm"
          onClick={() => handleChangeLanguage('vn')}
        >
          VN
        </li>
        <li
          className="cursor-pointer px-3 py-2 text-[12px] font-medium text-[#4b5a42] transition-colors duration-200 hover:bg-[#e7decd] hover:text-[#223A27] md:text-sm"
          onClick={() => handleChangeLanguage('zh')}
        >
          中文
        </li>
        <li
          className="cursor-pointer px-3 py-2 text-[12px] font-medium text-[#4b5a42] transition-colors duration-200 hover:bg-[#e7decd] hover:text-[#223A27] md:text-sm"
          onClick={() => handleChangeLanguage('en')}
        >
          EN
        </li>
      </ul>
    </div>
  );
};

export default memo(DesktopLanguageSelectorClient);
